import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { InitialDataResolver } from 'app/app.resolvers';
import {AuthAdminGuard} from "./core/auth/guards/authAdmin.guard";

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
    {path: '', pathMatch : 'full', redirectTo: 'project'},
    //{path: '', pathMatch : 'full', redirectTo: 'worksheet/worker'},

    // Redirect signed in user to the '/example'
    //
    // After the user signs in, the sign in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'project'},

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.module').then(m => m.AuthConfirmationRequiredModule)},
            {path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.module').then(m => m.AuthForgotPasswordModule)},
            {path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.module').then(m => m.AuthResetPasswordModule)},
            {path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.module').then(m => m.AuthSignInModule)},
            {path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.module').then(m => m.AuthSignUpModule)},
            //{path: 'invoices', loadChildren: () => import('app/modules/admin/worksheet/worksheet.module').then(m => m.WorksheetModule)}
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.module').then(m => m.AuthSignOutModule)},
            {path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.module').then(m => m.AuthUnlockSessionModule)}
        ]
    },


    // Admin routes
    {
        path       : '',
        canActivate: [AuthAdminGuard],
        canActivateChild: [AuthAdminGuard],
        component  : LayoutComponent,
        resolve    : {
            initialData: InitialDataResolver,
        },
        children   : [
            {path: 'example', loadChildren: () => import('app/modules/admin/example/example.module').then(m => m.ExampleModule)},
            {path: 'contracts', loadChildren: () => import('app/modules/admin/contract/contract.module').then(m => m.ContractModule)},
            {path: 'home', loadChildren: () => import('app/modules/landing/home/home.module').then(m => m.LandingHomeModule)},
            {path: 'organizations', loadChildren: () => import('app/modules/admin/organization/organization.module').then(m => m.OrganizationModule)},
            {path: 'team', loadChildren: () => import('app/modules/admin/team/team.module').then(m => m.TeamModule)},
            {path: 'contractors', loadChildren: () => import('app/modules/admin/contractor/contractor.module').then(m => m.ContractorModule)},
            {path: 'technicians', loadChildren: () => import('app/modules/admin/technician/technician.module').then(m => m.TechnicianModule)},
            {path: 'project', loadChildren: () => import('app/modules/admin/project/project.module').then(m => m.ProjectModule)},
            {path: 'devices', loadChildren: () => import('app/modules/admin/device/device.module').then(m => m.DeviceModule)},

            //{path: 'invoices', loadChildren: () => import('app/modules/admin/contract/contract.module').then(m => m.ContractModule)}
        ]
    },

    // Employees routes
    {
        path       : '',
        component  : LayoutComponent,
        canActivate: [AuthGuard],
        children   : [
            {path: 'worksheet', loadChildren: () => import('app/modules/admin/worksheet/worksheet.module').then(m => m.WorksheetModule)},
        ]
    }
];
